import LearnLayout, { LEARN_PAGES } from './LearnLayout'

const page = LEARN_PAGES.find((p) => p.slug === 'adenomyosis')!

export default function AdenomyosisPage() {
  return (
    <LearnLayout page={page}>
      <h2 id="architecture">The architecture you need to understand</h2>
      <p>
        Your uterus has three layers. The inner lining is the <strong>endometrium</strong>, what
        sheds during your period. The outer layer is the <strong>serosa</strong>. The thick middle
        layer is the <strong>myometrium</strong>: solid, smooth muscle, responsible for
        contractions.
      </p>
      <p>
        Between the endometrium and myometrium there&rsquo;s a specialized transition zone called
        the <strong>junctional zone (JZ)</strong>. It&rsquo;s not just a boundary. It&rsquo;s a
        distinct tissue type with its own contractile function. Think of it as the uterus&rsquo;s
        internal gatekeeper.
      </p>
      <p>
        In adenomyosis, that gatekeeper fails. Endometrial glands and stroma breach the junctional
        zone and invade into the myometrium.
      </p>

      <h2 id="muscle-breaks-down">Why the muscle wall breaks down</h2>
      <p>
        The leading theory centers on <strong>junctional zone disruption</strong>, which can result
        from repeated microtrauma from uterine contractions over years of menstruation, surgical
        disruption from prior C-sections or D&amp;Cs, or stem cell metaplasia where endometrial stem
        cells migrate into the myometrium directly.
      </p>
      <p>
        Once endometrial tissue is embedded in the muscle, it responds to hormonal cycling. It
        proliferates under estrogen, attempts to shed under progesterone, but it has nowhere to go.
        The bleeding is trapped inside the muscle wall.
      </p>

      <div className="learn-bottom-line">
        <span className="learn-bottom-line-label">The bottom line</span>
        <p>
          Adenomyosis is a structural disease of the uterine muscle driven by endometrial invasion,
          estrogen amplification, progesterone resistance, and disordered myometrial function. It
          causes heavy, painful periods, a chronically enlarged uterus, and frequently co-exists
          with endometriosis (estimated 20&ndash;50% overlap). The only definitive cure is
          hysterectomy, which is why earlier recognition, hormone management, and surgical planning
          matters enormously for younger patients who haven&rsquo;t completed their families.
        </p>
      </div>
    </LearnLayout>
  )
}
